import { MaterialMakeFrom } from '@pt/enums/push'

// 推送接口使用，素材制作方式来源
export const materialMakeFrom = {
  custom: MaterialMakeFrom.Custom, // 交付列表
  dmaker: MaterialMakeFrom.Dmaker, // 在线制作
  gmaker: MaterialMakeFrom.Gmaker, // 通用模板
  playsmart: MaterialMakeFrom.Playsmart, // PlaySmart
  veditor: MaterialMakeFrom.Veditor, // VEditor
}
